import { ru } from 'date-fns/locale';
import { Langs } from 'libs/i18n';

export const mapI18nLocalToDateFns = (language: Langs) => {
  const locals: Record<Langs, typeof ru> = {
    [Langs.RU]: ru,
  };
  return locals[language];
};
